import { Tooltip } from "react-tooltip";
import { createPortal } from "react-dom";
import { ITooltip } from "react-tooltip";

interface IPortalTooltipProps extends ITooltip {
  children: React.ReactNode;
}

export const PortalTooltip = ({
  children,
  ...props
}: IPortalTooltipProps) => {
  return createPortal(
    <Tooltip {...props}>{children}</Tooltip>,
    document.body
  );
};
